import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';
import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import { Placeholder } from '@tiptap/extensions'

@Component({
    selector: 'nx-edit-tipTap-input',
    host: {
        'class': 'nx-edit-tipTap-input w-full'
    },
    template: `
        <label for="text">{{label | translate}}<ng-container *ngIf=isRequired()>*</ng-container></label>
        <div class="editorWrapper flex flex-col w-full" [ngClass]="{ 'focused': isEditorFocused }">
            <div class="p-1 flex buttons w-full">
                <button
                    id="bold"
                    [ngClass]="{ 'active': this.editor?.isActive('bold') }"
                    (click)="editor.chain().focus().toggleBold().run()">
                    B
                </button>
                <button
                    id="italic"
                    [ngClass]="{ 'active': this.editor?.isActive('italic') }"
                    (click)="editor.chain().focus().toggleItalic().run()">
                    I
                </button>
                <button
                    id="bulletList"
                    [ngClass]="{ 'active': this.editor?.isActive('bulletList') }"
                    (click)="editor.chain().focus().toggleBulletList().run()">
                    Bullet list
                </button>
                <button
                    id="h1"
                    [ngClass]="{ 'active': this.editor?.isActive('heading', { level: 1 }) }"
                    (click)="editor.chain().focus().toggleHeading({ level: 1 }).run()">
                    H1
                </button>
                <button
                    id="h2"
                    [ngClass]="{ 'active': this.editor?.isActive('heading', { level: 2 }) }"
                    (click)="editor.chain().focus().toggleHeading({ level: 2 }).run()">
                    H2
                </button>
                <button
                    id="h3"
                    [ngClass]="{ 'active': this.editor?.isActive('heading', { level: 3 }) }"
                    (click)="editor.chain().focus().toggleHeading({ level: 3 }).run()">
                    H3
                </button>
            </div>
            <div #editorElement class="editor w-full"></div>
        </div>
        <small *ngIf="helpText">{{helpText | translate}}</small>
  `,
    styles: [`
  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditTipTapInputComponent),
            multi: true
        }
    ]
})
export class EditTipTapInputComponent implements ControlValueAccessor, OnInit, AfterViewInit {

    @ViewChild('editorElement', { read: ElementRef }) editorElement: ElementRef;

    isEditorFocused = false;

    ngControl: NgControl;
    isDisabled: boolean;
    @Input() label: string;
    @Input() placeholder: string = 'Schreibe etwas...';
    @Input() helpText: string;
    @Input() maskContent: boolean = false;

    private _isEmpty: boolean = true;
    @Output() isEmptyChange = new EventEmitter<boolean>();

    editor: Editor;

    text: any;
    // editor = new Editor({
    //     extensions: [StarterKit],
    // });

    private onChange: (value: any) => void;
    private onTouched: () => void;

    constructor(private _injector: Injector) {

    }

    ngAfterViewInit(): void {
        this.editor = new Editor({
            element: this.editorElement.nativeElement,
            extensions: [StarterKit,
      Placeholder.configure({
        // Use a placeholder:
        placeholder: this.placeholder,
        // Use different placeholders depending on the node type:
        // placeholder: ({ node }) => {
        //   if (node.type.name === 'heading') {
        //     return 'What’s the title?'
        //   }

        //   return 'Can you add some further context?'
        // },
      }),],
            content: this.text || '',
            editorProps: {
                attributes: {
                    spellcheck: 'false',
                },
            },
        })
        this.editor.on('focus', () => {
            this.isEditorFocused = true;
        });
        this.editor.on('blur', () => {
            this.isEditorFocused = false;
        });
        this.editor.on('update', () => {
        const html = this.editor.getJSON();
        this.text = html;
        let isEmpty = this.isEmpty();
        if (this._isEmpty !== isEmpty) {
            this._isEmpty = isEmpty;
            this.isEmptyChange.emit(this._isEmpty);
        }
        if (this.onChange) {
            this.onChange(html);
        }
    });
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(text: string): void {
        this.text = text;
        if (this.editor) {
            this.editor.commands.setContent(text);
        }
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Optional: Implementieren Sie die Logik zum Deaktivieren des Steuerelements
        this.isDisabled = isDisabled;
    }

    onInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.text = input.value;
        if (this.onChange) {
            this.onChange(this.text);
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

    isEmpty(): boolean {
        return this.editor?.isEmpty;
    }

}
